export const bannersToHomeBanners = ({
  data,
}: Banner.Root): Banner.Component | null => {
  if (data.campaigns.length) {
    for (const item of data.campaigns) {
      const component = item.campaign.components.find(
        (c) => c.type === 'carousel'
      );

      if (component) {
        return component;
      }
    }
  }

  return null;
};
